import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "./App.css";
import Header from "./Component/Header";
import Footer from "./Component/Footer";
import Home from "./Pages/Home";
import About from "./Pages/About";
import Services from "./Pages/Services";
import Portfolio from "./Pages/Portfolio";
import Blog from "./Pages/Blog";
import Partner from "./Pages/Partner";
import Contactus from "./Pages/Contactus";
import Careerus from "./Pages/Careerus";
import Login from "./Admin/Login";
import AdminLayout from "./Admin/AdminLayout";
import AdminDashboard from "./Admin/AdminDashboard";
import AdminUsers from "./Admin/AdminUsers";
import PrivateRoute from "./Routes/PrivateRoute";
import BlogManagement from "./Admin/BlogManagement";
import AdminJobPanel from "./Admin/AdminJobPanel";
import AdminJobApply from "./Admin/AdminJobApply";
import ScrollToTop from "./Component/ScrollTop";

const AppRoutes = () => {
  const location = useLocation();
  const hideLayout =
    location.pathname.startsWith("/admin") && location.pathname !== "/admin";

  return (
    <>
      {!hideLayout && <Header />}

      <ScrollToTop />
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Home />} />
        <Route path="/aboutus" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/partnershipwithus" element={<Partner />} />
        <Route path="/contactus" element={<Contactus />} />
        <Route path="/career" element={<Careerus />} />

        {/* Admin Login (Public) */}
        <Route path="/admin" element={<Login />} />

        {/* Protected Admin Routes */}
        <Route
          path="/admin"
          element={
            <PrivateRoute>
              <AdminLayout />
            </PrivateRoute>
          }
        >
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="users" element={<AdminUsers />} />
          <Route path="jobapply" element={<AdminJobApply />} />
          <Route path="blogmanagement" element={<BlogManagement />} />
          <Route path="career" element={<AdminJobPanel />} />
        </Route>
      </Routes>

      {!hideLayout && <Footer />}
    </>
  );
};

function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
